<template>
  <div class="v-title">
        <div class="v-title-text">{{title}}</div>
        <div v-if="more" class="v-more-text" @click="$emit('jump')">
            {{moreText}}
            <img class="v-r-icon" src="http://album.usho.cn/www/upload/f5a713722f5583da90e7da275b7eb491.png" alt="">
        </div>
  </div>
</template>

<script>
export default {
   props: {
      title: String,
      moreText:String,
      more:{
          type:Boolean,
          default:true
      },
      link:String,
      linkType:{
          type:String,
          default:'page2'
      }

   },

  data () {
    return {

    }
  },
  computed:{

  },
  created(){

  },
  mounted(){
   
  },
  methods:{

  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" >
.v-title{
    width: 100%;
    overflow: hidden;
    padding:0 0.8rem;
    .v-title-text{
        float: left;
        font-size: 0.8rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 1.1rem;
    }
    .v-more-text{
        float: right;
        font-size: 0.65rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 0.9rem;
        .v-r-icon{
            width: 0.8rem;
            height: 0.8rem;
            vertical-align: top;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/title.vue